<!-- ----------------------------------------------- -->
<template>
  <div class="legend-content">
    <v-container style="align-items:center">
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwLevel5" style="height: 30px;" />
        </v-col>
        <v-col :cols="4" align-self="end">
          <span class="location-text pl-2 float-left">
            {{ text.snwLevel5 }}
          </span>
        </v-col>
        <v-col :cols="3" align-self="end">
          <span class="location-text pl-2 float-left">
            [cm]
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwLevel4" style="height: 30px;" />
        </v-col>
        <v-col :cols="8" align-self="end">
          <span class="location-text pl-2 float-left">
            {{ text.snwLevel4 }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwLevel3" style="height: 30px;" />
        </v-col>
        <v-col :cols="8" align-self="end">
          <span class="location-text pl-2 float-left">
            {{ text.snwLevel3 }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwLevel2" style="height: 30px;" />
        </v-col>
        <v-col :cols="8" align-self="end">
          <span class="location-text pl-2 float-left">
            {{ text.snwLevel2 }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwLevel1" style="height: 30px;" />
        </v-col>
        <v-col :cols="8" align-self="end">
          <span class="location-text pl-2 float-left">
            {{ text.snwLevel1 }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwNormal" style="height: 30px;" />
        </v-col>
        <v-col :cols="8" align-self="end">
          <span class="location-text pl-2 float-left">
            {{ text.snwNormal }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.obs_snow_0_over" style="height: 30px;" />
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwLevel0" style="height: 30px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2 float-left">
            {{ text.snwLevel0 }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.snwMissing" style="height: 30px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2 float-left">
            {{ text.snwMissing }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 積雪深
 * LegendTmSnw.vue
 * @author LIS
 */
export default {
  name: "legend-tm-snw",
  data() {
    return {
      /** アイコン */
      imgResource: {
        snwLevel5: "/kawabou/img/map_icons/obs_snow_200.svg",
        snwLevel4: "/kawabou/img/map_icons/obs_snow_150.svg",
        snwLevel3: "/kawabou/img/map_icons/obs_snow_100.svg",
        snwLevel2: "/kawabou/img/map_icons/obs_snow_50.svg",
        snwLevel1: "/kawabou/img/map_icons/obs_snow_20.svg",
        snwNormal: "/kawabou/img/map_icons/obs_snow_5.svg",
        obs_snow_0_over: "/kawabou/img/map_icons/obs_snow_0_over.svg",
        snwLevel0: "/kawabou/img/map_icons/obs_snow_0.svg",
        snwMissing: "/kawabou/img/map_icons/obs_snow_missing.svg",
      },
      /** 文字列リソース */
      text: {
        snwLevel5: "200",
        snwLevel4: "150",
        snwLevel3: "100",
        snwLevel2: "50",
        snwLevel1: "20",
        snwNormal: "5",
        snwLevel0: "0",
        snwMissing: "欠測",
        snwUnit: "[cm]",
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.legend-content {
  width: 220px;
  .location-img {
    display: flex;
    justify-content: flex-end;
    position: relative;
  }
  .location-text {
    font-size: 0.9rem;
    color: black;
    margin-bottom: calc(22px - 30px);
  }
}
</style>
